import { usePlatformLog } from '@church/data'
import { Link, createFileRoute } from '@tanstack/react-router'
import { Button, Card, ErrorNote, PageHeader, Spinner } from '../components/ui.tsx'

/** What platform operators did: plans edited, churches' plans and overrides changed. */
export const Route = createFileRoute('/_authed/admin/log')({
  component: PlatformLog,
})

function PlatformLog() {
  const log = usePlatformLog()
  if (log.isPending) return <Spinner />
  const entries = log.data?.pages.flatMap((p) => p.entries) ?? []
  return (
    <div className="space-y-6">
      <PageHeader visible title="Log" />
      <ErrorNote error={log.error} />
      <Card className="divide-y divide-border-subtle text-sm">
        {entries.length === 0 && <p className="p-4 text-content-muted">Nothing yet.</p>}
        {entries.map((e) => (
          <div key={e.id} className="space-y-1 px-4 py-3">
            <div className="flex flex-wrap justify-between gap-2">
              <span className="font-mono text-xs text-content-default">{e.action}</span>
              <span className="text-xs text-content-muted">
                {e.actorEmail ?? 'someone'} · {new Date(e.createdAt).toLocaleString()}
              </span>
            </div>
            {e.organizationId && (
              <Link
                to="/admin/churches/$id"
                params={{ id: e.organizationId }}
                className="text-xs text-content-brand hover:underline"
              >
                the church
              </Link>
            )}
            {e.reason && <p className="text-content-default">“{e.reason}”</p>}
            {e.after && (
              <pre className="overflow-x-auto rounded bg-surface-sunken p-2 text-xs text-content-muted">
                {JSON.stringify(e.after, null, 1)}
              </pre>
            )}
          </div>
        ))}
      </Card>
      {log.hasNextPage && (
        <Button variant="secondary" onClick={() => void log.fetchNextPage()}>
          Older
        </Button>
      )}
    </div>
  )
}
